// eslint-disable-next-line import/named
import Glide, { Options } from '@glidejs/glide';

window.aguadecoco = window.aguadecoco || {};
Object.assign(window.aguadecoco, {
  helpers: Object.assign(window.aguadecoco.helpers || {}, {
    slider: (containerIdentifier: string | HTMLElement, config?: Options & { showDots?:boolean }, autoMount?: boolean) => {
      const slider = new Glide(containerIdentifier, config);
    

      if (config?.showDots) {
        // @ts-ignore
        const $s = $(containerIdentifier) as unknown as JQuery<HTMLElement>;
        const $bulletContainer = $(
          '<div class="glide__bullets glide__custom__bullets" data-glide-el="controls[nav]"></div>',
        );

        const $qntSlider = Array.from($s.find('.glide__slides').children());
        $qntSlider.forEach((_slide, index) => {
          const $bullet = $(`<button class="glide__bullet" data-glide-dir="=${index}">${index}</button>`);
          $bulletContainer.append($bullet);
        });

        $s.append($bulletContainer);
      }

        if (autoMount) {
          slider.mount();
        }
      
      return slider;
    },
  }),
});

const $sliders = document.querySelectorAll('.glide[data-glide]');

if ($sliders.length) {
  for (const $slider of Array.from($sliders)) {
    let config = {
      type: 'carousel',
      perView: 1,
      autoplay: 1000,
      direction: 'rtl',
    } as Options & {showArrow: boolean, showDots: boolean};
    const configText = $slider.getAttribute('data-glide');
    if ($slider.classList.contains('slider-ready')) {
      continue;
    }

    try {
      if (configText) {
        config = {
          ...config,
          ...JSON.parse(configText),
        };
      }
    } catch (e) {
      console.error(
        '🔴 Atenção, existe erro na configuração do JSON para o banner\n\n',
        configText,
        '\n\n',
        $slider,
        '\n\n',
        e,
      );
    }
  

    window.aguadecoco.helpers.slider($slider, config, true);
    $slider.classList.add('slider-ready');
  }
}
